export default {
  programming: {
    languages: {
      good: ['TypeScript', 'Go', 'C / C++'],
      ok: ['Rust', 'Python'],
    },
    space: [4],
    list: [
      'Practical knowledge of <b>Go</b>, <b>Rust</b>, and <b>C/C++</b> in general, application, object-oriented, network, and <b>embedded</b> programming.',
      'Integration of <b>AI</b> with other application layers. Practical knowledge of <b>machine learning</b> and <b>deep learning</b> fields.',
      'Programming desktop and web applications using <b>Vue</b> technology and <b>TypeScript</b>.',
      'Database management - experience with <b>SQLite</b>, <b>MongoDB</b>, and <b>MySQL</b>. Basics of DevOps, including <b>Google Cloud</b>.',
      'Ability to <b>model physical processes</b> and run <b>computer simulations</b>, including the use of <b>ML</b>.',
      'Knowledge of computational materials engineering methods such as <b>Monte Carlo</b>, <b>molecular dynamics</b>, and <b>DFT</b>.',
    ],
  },
  technical: {
    space: [3, 6],
    list: [
      'Knowledge of <b>operating systems</b> and <b>computer architecture</b>. Working in <b>Linux / UNIX</b> systems, including <b>shell</b> proficiency.',
      'Basic knowledge of <b>teleinformatics</b>, in areas such as computer networks and data security.',
      'Practical knowledge in the field of <b>telecommunications</b>. Configuring installations and creating internet systems.',
      'Operation of computer and measuring equipment. <b>Computerization of measurements</b> in <b>LabVIEW</b>.',
      'Diagnostics and repair of <b>electronic devices</b>. Ability to read <b>electronic schematics</b>.',
      'Basics of operation and programming of <b>AVR</b> microcontrollers and embedded systems, specifically <b>Arduino</b>.',
      'Ability to create and read <b>technical drawings</b> and create 2D and 3D schematics in <b>NX</b> software.',
      'Experience in advanced materials research methods such as: <b>XRD, DSC, DTA / TGA, TMA, XAS</b>, as well as <b>spectroscopy</b>: absorption, luminescence, impedance, or infrared.',
    ],
  },
  science: {
    space: [5],
    list: [
      'Comprehensive knowledge of processes and technologies used in the <b>physics and chemistry of advanced materials</b>.',
      'Experience in the <b>physics of ionic processes</b>, particularly in energy <b>processing and storage</b> technologies.',
      'Knowledge of modern applications of <b>semiconductor structure physics</b> and <b>solid-state electronics</b>.',
      'Practical knowledge of theory and technological processes in the production of <b>nanostructures</b> and <b>low-dimensional systems</b>.',
      'Practical knowledge and problem-solving in the fields of <b>laser physics</b>, <b>optoelectronics and photonics</b>, and applications of <b>nuclear physics</b>.',
      'Knowledge of elements of advanced <b>higher mathematics</b> in <b>engineering and programming applications</b>.',
      'Basic knowledge of <b>statistics and data analysis</b> in <b>ROOT</b> and <b>Python</b>. Working with <b>NumPy</b>, <b>Pandas</b>, and <b>Matplotlib</b> libraries.',
      'Basic ability to perform <b>numerical</b> and symbolic calculations in <b>Mathematica</b> and <b>Python</b>.',
    ],
  },
  soft: {
    list: [
      'Ease in <b>acquiring knowledge</b>. Fast <b>learning</b>, <b>flexibility</b>, and <b>adaptation</b> to changes.',
      'Ability in <b>project management</b> and <b>teamwork</b>. Experience as a leader and team member.',
      'Good <b>communication</b> and organizational <b>skills</b>. <b>Openness in interacting</b> with people.',
      'Experience in specialized communication in <b>English</b> confirmed by participation in scientific conferences.',
      'Ability for <b>logical, creative, and critical thinking</b>.',
    ],
  },
}
